import React from "react";
import {
  Alert,
  Box,
  Button,
  Container,
  ContentLayout,
  Header,
  SpaceBetween,
} from "@cloudscape-design/components";
import { payloadFromToken } from "../api/auth";
import { PRIVILEGED_USERS } from "../constants/auth";

function AdminIndex() {
  const [username, setUsername] = React.useState("");

  React.useEffect(() => {
    const storedToken =
      window.localStorage.getItem("id_token") ||
      window.localStorage.getItem("access_token");

    if (!storedToken) return;

    try {
      const payload = payloadFromToken(storedToken);
      const derivedUsername =
        payload?.["cognito:username"] || payload?.username || payload?.email;
      if (derivedUsername) {
        setUsername(derivedUsername);
      }
    } catch (err) {
      console.debug("Unable to derive username from token", err);
    }
  }, []);

  const isPrivileged = PRIVILEGED_USERS.includes(username);

  if (!isPrivileged) {
    return (
      <ContentLayout header={<Header variant="h1">Admin</Header>}>
        <Container>
          <Alert
            statusIconAriaLabel="Info"
            header="Access restricted"
            variant="info"
          >
            You do not have permission to view admin resources.
          </Alert>
        </Container>
      </ContentLayout>
    );
  }

  return (
    <ContentLayout header={<Header variant="h1">Admin</Header>}>
      <Container>
        <SpaceBetween size="m">
          <Box variant="awsui-key-label">Admin tools</Box>
          <Box color="text-body-secondary">
            Manage privileged resources and configurations.
          </Box>
          <SpaceBetween size="s" direction="horizontal">
            <Button variant="primary" href="/admin/phone-directory">
              Go to Phone Directory
            </Button>
            <Button href="/admin/reports">View Reports</Button>
          </SpaceBetween>
        </SpaceBetween>
      </Container>
    </ContentLayout>
  );
}

export default AdminIndex;
